import React from 'react'
import { Wrapper } from './Footer.styles'

export default function Footer() {
    return (
        <Wrapper>
            <p>created by <a href='https://github.com/youhane' target="_blank" rel="noreferrer">youhane</a> - devChallenges.io</p>
        </Wrapper>
    )
}
